import React from 'react';
import { connect } from 'react-redux';
import { Button, Label } from 'reactstrap';
import { getFileUploadURL, uploadFile } from '../../../actions/file-upload';

class FileUpload extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      file: '',
      error: false,
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({ file: e.target.files[0] });
  }

  render() {
    const {
      label,
      id,
      values,
      dispatch,
    } = this.props;
    const { file, error } = this.state;

    return (
      <>
        <div className="d-flex">
          <Label className="font-weight-bold">{label}</Label>
          {error ? <div className="text-danger ms-3">Could Not Upload.</div> : null}
        </div>
        <div className="d-flex align-items-center mb-3">
          <Button
            onClick={() => {
              getFileUploadURL(file.name)
                .then((data) => {
                  const uploadURL = data.url;
                  const uploadFields = data.fields;

                  uploadFile(file, data)
                    .then(() => {
                      dispatch({
                        type: 'EDIT_SITE_THEME',
                        id,
                        value: `${uploadURL}${uploadFields.key}`,
                        category: 'images',
                        categoryType: 'object',
                      });
                    })
                    .catch(() => {
                      this.setState({ error: true });
                    });
                })
                .catch(() => {
                  this.setState({ error: true });
                });
            }}
            className="me-2"
            disabled={!file}
          >
            {values.images && values.images[id] ? 'Replace' : 'Upload'}
          </Button>
          <input type="file" onChange={this.onChange} />
        </div>
      </>
    );
  }
}

const mapStateToProps = (store) => ({
  values: store.sites.values,
});

export default connect(mapStateToProps)(FileUpload);
